import classnames from 'classnames'
import moment from 'moment'
import TotalPrice from './TotalPrice'
import styles from 'purchase-flow/brazil/components/styles.module.scss'
import bookingStyles from './styles.module.scss'
import Icon from '@components/Icon'

const ProductDetails = ({
    rate,
    discountedTotalPrice,
    startDate,
    endDate,
    locationName,
    vehicles,
    additionalServices,
}) => (
    <div className={classnames(styles.productDetails, bookingStyles.productDetails)}>
        <TotalPrice rate={rate} discountedTotalPrice={discountedTotalPrice} additionalServices={additionalServices} />
        <span className={bookingStyles.dateContainer}>
            <span className={styles.lineDescription}>
                <T>booking.review.pay.data.start</T>:{' '}
            </span>
            <span>{moment(startDate).format('DD-MM-YYYY hh:mm A')}</span>
            <span className={styles.lineDescription}>
                <T>booking.review.pay.data.end</T>:{' '}
            </span>
            <span>{moment(endDate).format('DD-MM-YYYY hh:mm A')}</span>
        </span>
        <div className={classnames(bookingStyles.location, 'd-flex')}>
            <Icon type="pin" size="xxs" />
            <span className="ml-1">{locationName}</span>
        </div>

        <div className={classnames(bookingStyles.vehicle, 'd-flex')}>
            <Icon type="car" size="xxs" />
            <span className="ml-1">{vehicles[0].tag}</span>
        </div>
    </div>
)

export default ProductDetails
